import { CONTACT } from "../../types";

export const ContactReducer = (state, action) => {
  switch (action.type) {
    case CONTACT.EXIST:
      return {
        ...state,
        exist: action.payload,
      };
    case CONTACT.CURRENTCONTACT:
      return {
        ...state,
        currentContact: action.payload.data,
        isActive: action.payload.userSignUp.activE_STATE,
        isApproved: action.payload.userSignUp.approvaL_STATE,
        isPendingApproval: action.payload.userSignUp.pendinG_APPROVAL,
        isSecondary: action.payload.secondary,
      };
    case CONTACT.VENDOR:
      return {
        ...state,
        vendor: action.payload,
      };
    case CONTACT.COMPANY:
      return {
        ...state,
        company: action.payload,
      };
    case CONTACT.RUCVENDOR:
      return {
        ...state,
        rucVendor: action.payload,
      };
    case CONTACT.PRIMARYCONTACT:
      return {
        ...state,
        primaryContact: action.payload,
      };
    case CONTACT.SECONDARYCONTACT:
      return {
        ...state,
        secondaryContact: action.payload,
      };
    case CONTACT.CARRIERCONTACT:
      return {
        ...state,
        carrierContact: action.payload,
      };
    case CONTACT.APPROVALSENT:
      return {
        ...state,
        approvalSent: action.payload,
      };
    case CONTACT.START_ENROLLMENT:
      return {
        ...state,
        startEnrollment: action.payload,
        enrollment: action.payload,
      };
    case CONTACT.ENROLLMENT:
      return {
        ...state,
        enrollment: action.payload,
      };
    case CONTACT.CREATED:
      return {
        ...state,
        approvalSent: action.payload.approvalSent,
        created: action.payload.created,
        primaryContactCreated: action.payload.primaryContactCreated,
      };
    case CONTACT.PRIMARY_CREATED:
      return {
        ...state,
        approvalSent: action.payload,
        primaryContactCreated: action.payload,
      };
    case CONTACT.SECONDARY_CREATED:
      return {
        ...state,
        approvalSent: action.payload,
        secondContactCreated: action.payload,
      };
    case CONTACT.VEND_INFORMATION:
      return {
        ...state,
        vendorInformation: action.payload.vendorInformation,
        rucVendor: action.payload.ruc,
      };
    case CONTACT.VENDORCREATED:
      return {
        ...state,
        vendorCreated: action.payload,
      };
    case CONTACT.PURCHASE_ORDERS:
      return {
        ...state,
        purchaseOrders: action.payload,
      };
    case CONTACT.PURCH_LINES:
      return {
        ...state,
        purchLines: action.payload,
      };
    case CONTACT.ISACTIVE:
      return {
        ...state,
        isActivePrimary: action.payload.primary,
        isActiveSecondary: action.payload.secondary,
        vendorInformation: action.payload.vendorInformation,
      };
    case CONTACT.WIDTHNAVBAR:
      return {
        ...state,
        widthNavBars: action.payload,
      };
    case CONTACT.LEGALDOCUMENT:
      return {
        ...state,
        legalDocument: action.payload,
      };
    case CONTACT.PERSONALDATA:
      return {
        ...state,
        personalData: action.payload,
      };
    //Vendor
    default:
      return state;
  }
};
